





import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
class FolderItemView5SettingsView extends Vue {
  //
}

export default FolderItemView5SettingsView

